var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-loader-h2h"},[_c('svg',{staticClass:"loader__spinner",attrs:{"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"fill":"#9E9EB4","d":"M16 8a8 8 0 11-3.6-6.7l-1.6 2.5A5 5 0 1013 8h3z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }